module.exports = __webpack_public_path__ + "static/media/app-store.e43a8e5e.svg";